// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"597f587d","362":"da010d49","918":"79c28923"}[chunkId] + ".chunk.css";
};